// extracted by css-extract-rspack-plugin
export default {"cls1":"Banner-cls1_3oM","cls2":"Banner-cls2_F9t Banner-cls1_3oM"};